import { IShareData } from 'web-core-src';

export class ShareData implements IShareData {
    constructor(url: string, title: string) {
        this.url = url;
        this.title = title;
    }

    public url: string = '';
    public title: string = '';
}

export class PinterestShareData extends ShareData {
    constructor(url: string, title: string, media: string) {
        super(url, title);
        this.media = media;
    }

    public media: string = '';
}

export class TwitterShareData extends ShareData {
    constructor(url: string, title: string, hashtags: string, via: string) {
        super(url, title);
        this.hashtags = hashtags;
        this.via = via;
    }

    public hashtags: string = '';
    public via: string = '';
}
